<script>
  import ProductCard from "./ProductCard.svelte";
  export let prodList;
</script>

<style>

</style>

{#each prodList as plist, index}
  <ProductCard
    key={index}
    name={plist.name}
    price="{plist.price} SD"
    imgPath="../images/{plist.imgPath}"
    desc={plist.desc}
    on:onProductSelected />
{/each}
